// Step definitions shared between each track's pages and the AdvertiseLayout stepper.
export const AGENTS_STEPS = [
  { id: 'plan', label: 'Plan' },
  { id: 'profile', label: 'Profile' },
  { id: 'goals', label: 'Goals' },
  { id: 'schedule', label: 'Schedule' },
  { id: 'review', label: 'Review' },
];

export const SELLERS_STEPS = [
  { id: 'address', label: 'Address' },
  { id: 'verify', label: 'Verify' },
  { id: 'details', label: 'Details' },
  { id: 'contact', label: 'Contact' },
  { id: 'review', label: 'Review' },
  { id: 'checkout', label: 'Payment' },
];

export const BUILDERS_STEPS = [
  { id: 'company', label: 'Company' },
  { id: 'portfolio', label: 'Portfolio' },
  { id: 'contact', label: 'Contact' },
  { id: 'schedule', label: 'Schedule' },
  { id: 'review', label: 'Review' },
];
